import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=4d299b64&"
import script from "./Signup.vue?vue&type=script&lang=ts&"
export * from "./Signup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports